// removed by extract-text-webpack-plugin
module.exports = {"Nav":"Nav__2x1Sz","menuButton":"menuButton__3zr85","floatMenu":"floatMenu__3a74e","navItem":"navItem__10y_m","disabled":"disabled__3Ra2-"};